module.exports = __webpack_public_path__ + "img/gemDetaiIcon.7eec05ab.svg";